import { facilities, bedtypeList } from "@/api/shoppingData";

// 创建一个全局变量来存储字典数据
let dictionaryData = {};

export default function getDictionaryData() {
  // 如果有传入 app 实例，使用它来设置全局属性
  const setGlobalProperty = (key, value) => {
    // 更新本地存储
    dictionaryData[key] = value;
  };

  // 获取设施数据
  facilities()
    .then((res) => {
      if (res.code == 200) {
        if (res.data.error.code === 0) {
          let arrFacilities = res.data.list;
          let facility = {};

          for (let f of arrFacilities) {
            facility[f.code] = f.facilityNameLists;
          }
          
          setGlobalProperty('facility', facility);
        } else {
          console.log("facilities error code:" + res.data.error.code, res.data.error.message);
        }
      } else {
        console.log("facilities error code:" + res.code, res.message);
      }
    })
    .catch((error) => {
      console.log("facilities 请求失败", error.objError);
    });

  // 获取床型数据
  bedtypeList()
    .then((res) => {
      if (res.code == 200) {
        if (res.data.error.code == 0) {
          let arrbedtype = res.data.list;
          let bedtype = {};
          for (let b of arrbedtype) {
            bedtype[b.bedTypeCode] = b.bedTypeNameLists;
          }
          
          setGlobalProperty('bedtype', bedtype);
        } else {
          console.log("bedtypeList error code:" + res.data.error.code, res.data.error.message);
        }
      } else {
        console.log("bedtypeList error code:" + res.code, res.message);
      }
    })
    .catch((error) => {
      console.log("bedtypeList 请求失败", error.objError);
    });

  // 返回字典数据，以便在其他地方使用
  return dictionaryData;
}

// 提供一个方法获取字典数据
export function getDictionaryItem(key,value) {
  if (value !== undefined && value == "facility") {
     return dictionaryData.facility[key];
  }else{
    return dictionaryData.bedtype[key];
  }
}

// 提供一个方法设置字典数据
export function setDictionaryItem(key, value) {
  dictionaryData[key] = value;
  
  // 如果有可能，也更新全局属性
  if (typeof window !== 'undefined' && window.__VUE_APP__) {
    window.__VUE_APP__.config.globalProperties.$dictionaryData = {
      ...window.__VUE_APP__.config.globalProperties.$dictionaryData,
      [key]: value
    };
  }
}